import { useDetailApi } from "../../../swr/useApi";
import type { ProductWarrantyTypeDto } from "../../../api";
import { productWarrantyTypesService } from "../../api_client";

export function useProductWarrantyType(id?: number | null) {
    return useDetailApi<ProductWarrantyTypeDto>({
        key: `product-warranty-type-${id ?? "none"}`,
        serviceMethod: async () =>
            await productWarrantyTypesService.getProductWarrantyTypeById(
                id as number
            ),
        options: {
            isPaused: () => !id,
        },
    });
}
